import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

const YAPI = false

export const getRewardData = async (params: object) => {
  return await GET({
    url: YAPI
      ? 'http://yapi.bingex.com/mock/148/recommend/inviteAwardDetail'
      : '/v3/recommend/inviteAwardDetail',
    params,
    showError: false
  })
}
